<div class='subtitle' *ngIf='props.branch_count === 1'>{{props.service_count}} שירותים בסניף זה</div>
<div class='subtitle' *ngIf='props.branch_count > 1'>{{props.service_count}} שירותים בכתובת זו</div>
<div class='title'><span>{{props.full_title || props.title}}</span></div>
